import { render, staticRenderFns } from "./ApplicantOther.vue?vue&type=template&id=4d1f81fe&scoped=true&"
import script from "./ApplicantOther.vue?vue&type=script&lang=js&"
export * from "./ApplicantOther.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantOther.vue?vue&type=style&index=0&id=4d1f81fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1f81fe",
  null
  
)

export default component.exports